import './CameraWindow.css';
import { useRef, useState, useEffect } from 'react';
import { Client } from "@gradio/client";
import VideoStream from './VideoStream';
import ScreenshotButton from './ScreenshotButton';
import ScreenshotDisplay from './ScreenshotDisplay';
// import SolveButton from './SolveButton';
// import Latex from 'react-latex';
import { LaTeXJSComponent } from "latex.js"

// import { BlockMath, InlineMath } from 'react-katex';
// import 'katex/dist/katex.min.css';

const CameraWindow = () => {
  const videoRef = useRef(null);
  const [screenshot, setScreenshot] = useState(null);
  const [isStreamActive, setIsStreamActive] = useState(true);
  const [isSolving, setIsSolving] = useState(false);
  const [solution, setSolution] = useState(null);
  const [showImage, setShowImage] = useState(true);
  const [dots, setDots] = useState('...');

  useEffect(() => {
    if (!customElements.get('latex-js')) {
      customElements.define("latex-js", LaTeXJSComponent);
    }
  }, []);

  useEffect(() => {
    let interval;
    if (isSolving) {
      interval = setInterval(() => {
        setDots(prev => prev === '...' ? '.' : prev === '.' ? '..' : '...');
      }, 500);
    }
    return () => clearInterval(interval);
  }, [isSolving]);

  const takeScreenshot = () => {
    const video = videoRef.current;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0);
    
    const imageData = canvas.toDataURL('image/png');
    setScreenshot(imageData);
    setIsStreamActive(false);
  };

  const handleSolve = async () => {
    try {
      setIsSolving(true);
      setShowImage(false);
      
      const base64Response = await fetch(screenshot);
      const imageBlob = await base64Response.blob();

      const client = await Client.connect("Qwen/Qwen2.5-Math-Demo");
      const result = await client.predict("/math_chat_bot", { 
        image: imageBlob,
        sketchpad: null,
        question: "Solve this math problem",
      });

      let responseText = Array.isArray(result.data) ? result.data[0] : result.data;
      responseText = responseText.replace(/\\\\/g, '\\');
      
      setSolution(responseText);
    } catch (error) {
      console.error('Ошибка при решении:', error);
    } finally {
      setIsSolving(false);
    }
  };

  const handleCancel = () => {
    setScreenshot(null);
    setIsStreamActive(true);
    setSolution(null);
    setShowImage(true);
  };

  const renderSolution = (solutionText) => {
    if (!solutionText) {
      return null;
    }

    const text = (typeof solutionText === 'string' ? solutionText : String(solutionText)).replaceAll('**', '');
    return (
      <latex-js hyphenate="false" baseURL="https://cdn.jsdelivr.net/npm/latex.js/dist/">
        {`
          \\documentclass{article}
          \\begin{document}
          ${text}
          \\end{document}
        `}
      </latex-js>
    );
  };

  return (
    <div className="camera-window">
      <VideoStream videoRef={videoRef} isActive={isStreamActive} />
      {isStreamActive && <ScreenshotButton onClick={takeScreenshot} />}
      <ScreenshotDisplay 
        screenshot={screenshot} 
        onCancel={handleCancel}
        onSolve={handleSolve}
        isVisible={!isStreamActive && showImage}
        showOnlyCancel={!showImage}
        isSolving={isSolving}
      />
      {isSolving && <p>Решаем задачу{dots}</p>}
      {solution && (
        <div className="solution">
          {renderSolution(solution)}
        </div>
      )}
    </div>
  );
};

export default CameraWindow; 